import { gql } from "@apollo/client";

export const GET_POST_COMMENT = gql`
  query PostComment($where: PostCommentWhereInputOne!) {
    postComment(where: $where) {
        id
        name
        psid
        message
        type
        shop {
          id
          name
        }
        createdAt
        updatedAt
        note
        pageId
	      pageAccessToken
	      fbLiveId
	      isReply
	      isCreated
    }
}
`;

export const GET_POST_COMMENTS = gql`
  query PostComments($where: PostCommentWhereInput, $orderBy: OrderByInput, $skip: Int, $limit: Int) {
    postComments(where: $where, orderBy: $orderBy, skip: $skip, limit: $limit) {
      total
      data {
        id
        name
        psid
        message
        commentId
        type
        createdAt
        updatedAt
        note
        pageId
	      pageAccessToken
	      fbLiveId
	      isReply
	      isCreated
      }
    }
}
`;

export const GET_POST_COMMENTS_V2 = gql`
  query PostCommentsV2($where: PostCommentWhereInput, $orderBy: OrderByInput, $skip: Int, $limit: Int) {
  postCommentsV2(where: $where, orderBy: $orderBy, skip: $skip, limit: $limit) {
      data {
        total
        data {
          id
          name
          psid
          message
          commentId
          type
          createdAt
          updatedAt
          note
          pageId
          pageAccessToken
          fbLiveId
          isReply
          isCreated
        }
        totalPsCm
      }
  }
}
`;